import { PARAMS } from '../Player';
import Constants, { fixProtocol } from '../../../constants/constants';
import { httpGet } from '../../../modules/api/axios_api';
import { configuration } from './configuration';
import { Player } from './types';

export const getPlayers = async (parameters: {
  limit?: number;
  offset: number;
  players_to_exclude?: Player[];
  program_id?: number;
  query?: string;
}) => {
  const url = new URL(`${fixProtocol(Constants.BACKEND_URL)}/players/restorative-players`);
  const resultsLimit = parameters.limit || configuration.playersPerPage;

  if (parameters.program_id) {
    url.searchParams.append('program_id', parameters.program_id.toString());
  }

  url.searchParams.append('limit', `${resultsLimit}`);

  if (parameters.players_to_exclude) {
    const playersToExclude = parameters.players_to_exclude;
    playersToExclude.forEach((player) => {
      url.searchParams.append('player_ids_to_exclude', player.id.toString());
    });
  }

  if (parameters.query && parameters.query !== '') {
    url.searchParams.append('query', parameters.query);
  }

  typeof parameters.offset !== 'undefined' &&
    url.searchParams.append(PARAMS.PAGE, `${parameters.offset * resultsLimit}`);

  return httpGet(url.toString())
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw new Error('Error getting patient list', error);
    });
};
